module.exports = __webpack_public_path__ + "4f0c6e5af4fb6c670e5eeabdf5723d37.MP3";